import { IVisitPeriod } from "../types/ownerDashboard.types";

const MONTH_NAMES_FULL = [
  "janeiro",
  "fevereiro",
  "março",
  "abril",
  "maio",
  "junho",
  "julho",
  "agosto",
  "setembro",
  "outubro",
  "novembro",
  "dezembro",
];

export function paymentsPeriodToMonthValue(period: IVisitPeriod): string {
  const [month, , year] = period.initial_date.split("/");
  return `${year}-${month.padStart(2, "0")}`;
}

export function formatPaymentsPeriodLabel(period: IVisitPeriod): string {
  const [month, , year] = period.initial_date.split("/");
  const monthIndex = parseInt(month, 10) - 1;
  const monthName = MONTH_NAMES_FULL[monthIndex] ?? month;

  return `${monthName} de ${year}`;
}
